import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import { ACCOUNTBYPHONE, RESPONSEBASE } from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTransferLocalAccountDetailService,
  fetchTransferLocalAuthService,
  fetchTransferLocalConfirmService,
  fetchTransferLocalCreateService,
  fetchTransferLocalDetailByPhoneService,
} from "../services/transfer-local.service";
import {
  fetchTransferLocalAccountDetailFailure,
  fetchTransferLocalAccountDetailSuccess,
  fetchTransferLocalAuthorizationFailure,
  fetchTransferLocalAuthorizationSuccess,
  fetchTransferLocalConfirmFailure,
  fetchTransferLocalConfirmSuccess,
  fetchTransferLocalCreateFailure,
  fetchTransferLocalCreateSuccess,
  fetchTransferLocalDetailByPhoneFailure,
  fetchTransferLocalDetailByPhoneSuccess,
  fetchTransferLocalMakeFeeFailure,
  fetchTransferLocalMakeFeeSuccess,
} from "./actions";
import {
  FETCH_TRANSFER_LOCAL_ACCOUNT_DETAIL_REQUEST,
  FETCH_TRANSFER_LOCAL_AUTHORIZATION_KEY_REQUEST,
  FETCH_TRANSFER_LOCAL_CONFIRM_REQUEST,
  FETCH_TRANSFER_LOCAL_CREATE_REQUEST,
  FETCH_TRANSFER_LOCAL_DETAIL_BY_PHONE_REQUEST,
  FETCH_TRANSFER_LOCAL_MAKE_FEE_REQUEST,
} from "./actions.type";
import {
  FetchTransferLocalAccountDetailRequest,
  FetchTransferLocalAuthorizationRequest,
  FetchTransferLocalConfirmRequest,
  FetchTransferLocalCreateRequest,
  FetchTransferLocalDetailByPhoneRequest,
  FetchTransferLocalMakeFeeRequest,
} from "./types";

function* fetchTransferLocalAccountDetailSaga(action: FetchTransferLocalAccountDetailRequest) {
  try {
    if (action.showLoading) yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferLocalAccountDetailService(action));
    console.log("fetchTransferLocalAccountDetail response: ", response);
    if (action.showLoading) yield put(hideModal());
    if (response.status === 200) {
      const accountProfile = response.data.RESPONSEDATA?.ACCOUNTPROFILE;
      yield put(fetchTransferLocalAccountDetailSuccess(accountProfile));
    }
  } catch (e: any | AxiosError) {
    if (action.showLoading) yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferLocalAccountDetailFailure(msg));
  }
}

function* fetchTransferLocalDetailByPhoneSaga(action: FetchTransferLocalDetailByPhoneRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<ACCOUNTBYPHONE> = yield call(() => fetchTransferLocalDetailByPhoneService(action.payload));
    console.log("fetchTransferLocalAccountDetail response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferLocalDetailByPhoneSuccess(response.data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferLocalDetailByPhoneFailure(msg));
  }
}

function* fetchTransferLocalMakeFeeSaga(action: FetchTransferLocalMakeFeeRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferLocalCreateService(action.payload));
    console.log("fetchTransferLocalMakeFee response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferLocalMakeFeeSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferLocalMakeFeeFailure(msg));
  }
}

function* fetchTransferLocalCreateSaga(action: FetchTransferLocalCreateRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferLocalCreateService(action.payload));
    console.log("fetchTransferLocalCreate response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTransferLocalCreateSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferLocalCreateFailure(msg));
  }
}

function* fetchTransferLocalConfirmSaga(action: FetchTransferLocalConfirmRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferLocalConfirmService(action));
    console.log("fetchTransferLocalConfirm response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTransferLocalConfirmSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferLocalConfirmFailure(msg));
  }
}

function* fetchTransferLocalAuthSaga(action: FetchTransferLocalAuthorizationRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferLocalAuthService(action));
    console.log("fetchTransferLocalAuth response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTransferLocalAuthorizationSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferLocalAuthorizationFailure(getErrorEndOTP(e), msg));
  }
}

function* transferLocalSaga() {
  yield all([
    takeLatest(FETCH_TRANSFER_LOCAL_ACCOUNT_DETAIL_REQUEST, fetchTransferLocalAccountDetailSaga),
    takeLatest(FETCH_TRANSFER_LOCAL_DETAIL_BY_PHONE_REQUEST, fetchTransferLocalDetailByPhoneSaga),
    takeLatest(FETCH_TRANSFER_LOCAL_MAKE_FEE_REQUEST, fetchTransferLocalMakeFeeSaga),
    takeLatest(FETCH_TRANSFER_LOCAL_CREATE_REQUEST, fetchTransferLocalCreateSaga),
    takeLatest(FETCH_TRANSFER_LOCAL_CONFIRM_REQUEST, fetchTransferLocalConfirmSaga),
    takeLatest(FETCH_TRANSFER_LOCAL_AUTHORIZATION_KEY_REQUEST, fetchTransferLocalAuthSaga),
  ]);
}

export default transferLocalSaga;
